import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBackOfficeListLanguages: build.query<
      GetBackOfficeListLanguagesApiResponse,
      GetBackOfficeListLanguagesApiArg
    >({
      query: () => ({ url: `/v1/bo/languages` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetBackOfficeListLanguagesApiResponse =
  /** status 200 OK */ BackOfficeLanguageResponse[];
export type GetBackOfficeListLanguagesApiArg = void;
export type EntityLanguage = "en" | "de" | "de";
export type BackOfficeLanguageResponse = {
  defaultLocale?: string;
  label?: string;
  value?: EntityLanguage;
};
export const { useGetBackOfficeListLanguagesQuery } = injectedRtkApi;
